import { Component, HostBinding, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconRegistryService } from './icon-registry.service';

const PALETTE_COLORS = new Set(['primary', 'accent', 'warn']);

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() color?: string;

  @Input() svgIcon?: string;

  // `material-icons` drives the font ligature; `notranslate` stops browser
  // translation from rewriting the ligature text (e.g. "search"→"pesquisar")
  // and breaking the glyph — both mirror Material's mat-icon host.
  @HostBinding('class') readonly hostClass =
    'app-icon material-icons notranslate';

  @HostBinding('attr.aria-hidden') readonly ariaHidden = 'true';

  @HostBinding('style.color') get colorStyle(): string | null {
    return this.color && PALETTE_COLORS.has(this.color)
      ? `var(--app-icon-color-${this.color})`
      : null;
  }

  constructor(private readonly registry: IconRegistryService) {}

  get svg(): SafeHtml | null {
    return this.svgIcon ? this.registry.get(this.svgIcon) : null;
  }
}
